import React, { useEffect, useRef } from 'react';

import cx from 'classnames';

import { useMathJaxScriptLoader } from '../../utils/hooks';
import useStyles from './styles';

//NOTE!!!!! use useMathJaxScriptLoader hook to load script
const MathJaxBlock = ({ children, containerClass = '' }) => {
  let node = useRef(null);
  const classes = useStyles();
  const isMathJaxLoaded = useMathJaxScriptLoader();

  useEffect(() => {
    // @ts-ignore:
    if (window?.MathJax?.typesetPromise) {
      // @ts-ignore:
      window?.MathJax?.typesetPromise([node.current]);
    }
  }, [isMathJaxLoaded]);

  return (
    <div className={cx(classes.container, containerClass)} ref={node}>
      {children}
    </div>
  );
};

export default MathJaxBlock;
